import {api} from '../api';
import {errorMessage} from '../errors';
import {loadWorkspace, loadInbox} from '../services/workspaceRequests';
import type {GmailStatus} from '../types';
import type {ActionContext, WorkspaceActions} from './types';

export function createLifecycleActions({dispatch}: ActionContext): Pick<WorkspaceActions, 'refresh' | 'retry'> {
  let initializing: Promise<void> | null = null;
  async function refresh(): Promise<void> {
    const snapshot = await loadWorkspace();
    dispatch({type: 'patch', value: {...snapshot, error: ''}});
  }
  async function initialize(): Promise<void> {
    dispatch({type: 'patch', value: {loading: true, error: ''}});
    try { await refresh(); }
    catch (failure: unknown) { dispatch({type: 'patch', value: {error: errorMessage(failure)}}); }
    finally { dispatch({type: 'patch', value: {loading: false}}); }
  }
  function retry(): Promise<void> {
    if (!initializing) initializing = initialize().finally(() => { initializing = null; });
    return initializing;
  }
  return {refresh, retry};
}

export function createRecordActions({dispatch}: ActionContext): Pick<WorkspaceActions, 'putKnowledge' | 'removeKnowledge' | 'setNewOpen' | 'setSelected'> {
  return {
    putKnowledge: document => dispatch({type: 'knowledge-saved', document}),
    removeKnowledge: id => dispatch({type: 'knowledge-removed', id}),
    setNewOpen: newOpen => dispatch({type: 'patch', value: {newOpen}}),
    setSelected: selected => dispatch({type: 'patch', value: {selected}}),
  };
}

export function createGmailActions({dispatch}: ActionContext): Pick<WorkspaceActions, 'refreshGmail' | 'refreshInbox' | 'applyGmailSync'> {
  async function refreshGmail(): Promise<void> {
    dispatch({type: 'patch', value: {gmail: await api<GmailStatus>('/gmail/status')}});
  }
  async function refreshInbox(): Promise<void> {
    dispatch({type: 'inbox-refreshed', ...await loadInbox()});
  }
  return {refreshGmail, refreshInbox, applyGmailSync: result => dispatch({type: 'gmail-synced', result})};
}